import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  FaChevronDown, FaTwitter, FaLinkedinIn, FaFacebookF,
  FaMapMarkerAlt, FaEnvelope, FaPhoneAlt, FaInstagram,
  FaBars, FaTimes
} from 'react-icons/fa';

const Navbar = () => {
  const [isSticky, setIsSticky] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  // Stop background scrolling when menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [isMobileMenuOpen]);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'Volunteer', path: '/become-volunteer' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <header className="w-full font-sans relative">
      {/* DINNER TICKER */}
      <div className="bg-[#f9b50b] text-[#221f1f] py-3 overflow-hidden whitespace-nowrap border-b border-[#221f1f]/10 relative z-[50]">
        <div className="inline-block animate-marquee font-bold uppercase text-[12px] tracking-widest">
          Upcoming: Illinois Interfaith Annual Dinner — Feb 21st, 4:00 PM — 1919 Walnut Avenue, Hanover Park — Join the Dinner!
          <span className="mx-20 text-[#221f1f]/40">|||</span>
          Upcoming: Illinois Interfaith Annual Dinner — Feb 21st, 4:00 PM — 1919 Walnut Avenue, Hanover Park — Join the Dinner!
          <span className="mx-20 text-[#221f1f]/40">|||</span>
          Upcoming: Illinois Interfaith Annual Dinner — Feb 21st, 4:00 PM — 1919 Walnut Avenue, Hanover Park — Join the Dinner!
        </div>

        {/* CSS FOR TICKER ANIMATION */}
        <style dangerouslySetInnerHTML={{
          __html: `
          @keyframes marquee {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .animate-marquee {
            display: inline-block;
            animation: marquee 30s linear infinite;
            padding-left: 100%;
          }
        `}} />
      </div>

      {/* TOP BAR */}
      <div className="bg-[#221f1f] border-b border-white/10 py-3 hidden sm:block relative z-[50]">
        <div className="max-w-7xl mx-auto flex justify-between items-center px-4 md:px-10 text-[12px] md:text-[13px] text-white font-bold">
          <div className="flex items-center space-x-4 md:space-x-6">
            <a href="tel:+18477377065" className="flex items-center gap-2 group hover:text-[#f9b50b] transition-colors">
              <FaPhoneAlt className="text-[#f9b50b]" /> <span>+1 847-737-7065</span>
            </a>
            <a href="mailto:info@ilinterfaith.org" className="hidden lg:flex items-center gap-2 border-l border-white/10 pl-6 group hover:text-[#f9b50b] transition-colors">
              <FaEnvelope className="text-[#f9b50b]" /> <span>info@ilinterfaith.org</span>
            </a>
            <a href="https://maps.google.com/?cid=2605535385907448121&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQ" target="_blank" rel="noopener noreferrer" className="hidden xl:flex items-center gap-2 border-l border-white/10 pl-6 group hover:text-[#f9b50b] transition-colors">
              <FaMapMarkerAlt className="text-[#f9b50b]" /> <span>Hanover Park, IL, US</span>
            </a>
          </div>

          <div className="flex items-center space-x-4">
            <span className="hidden md:inline text-[11px] uppercase tracking-widest text-gray-500 mr-2">Follow:</span>
            <div className="flex items-center space-x-4">
              <a href="https://www.facebook.com/ILinterfaith" target="_blank" rel="noopener noreferrer" className="hover:text-[#f9b50b] transition-colors"><FaFacebookF /></a>
              <a href="https://x.com/IllinoisO22797" target="_blank" rel="noopener noreferrer" className="hover:text-[#f9b50b] transition-colors"><FaTwitter /></a>
              <a href="https://www.instagram.com/illinoisinterfaithorg/" target="_blank" rel="noopener noreferrer" className="hover:text-[#f9b50b] transition-colors"><FaInstagram /></a>
              <a href="https://www.linkedin.com/company/illinois-interfaith-organization-official/posts/?feedView=all" target="_blank" rel="noopener noreferrer" className="hover:text-[#f9b50b] transition-colors"><FaLinkedinIn /></a>
            </div>
          </div>
        </div>
      </div>

      {/* MAIN NAVIGATION */}
      <nav className={`w-full transition-all duration-500 z-[100] ${isSticky ? 'fixed top-0 left-0 bg-[#221f1f] shadow-xl' : 'relative bg-[#221f1f]'
        }`}>
        <div className="max-w-7xl mx-auto flex justify-between items-center h-20 px-4 md:px-10">
          <Link to="/" className="flex items-center">
            <div className=" p-1 rounded-sm mr-3">
              <img src="/Logo.png" alt="IIO Logo" className="h-20 md:h-24 w-auto" />
            </div>
          </Link>

          <div className="flex items-center h-full">
            <div className="hidden lg:flex space-x-1 font-bold uppercase text-[13px] tracking-widest h-full items-center text-white">
              <Link to="/" className={`px-4 h-full flex items-center hover:text-[#f9b50b] ${isActive('/') ? 'bg-[#f9b50b] text-[#221f1f]' : ''}`}>Home</Link>
              <Link to="/about" className={`px-4 h-full flex items-center hover:text-[#f9b50b] ${isActive('/about') ? 'bg-[#f9b50b] text-[#221f1f]' : ''}`}>About</Link>
              <div className="relative h-full group" onMouseEnter={() => setIsDropdownOpen(true)} onMouseLeave={() => setIsDropdownOpen(false)}>
                <button className={`px-4 h-full flex items-center gap-2 hover:text-[#f9b50b] ${isActive('/Events') || isActive('/annual-dinner') ? 'text-[#f9b50b]' : ''}`}>
                  EVENTS <FaChevronDown className={`text-[10px] transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`} />
                </button>
                <div className={`absolute left-0 top-full w-56 bg-[#221f1f] border-t-2 border-[#f9b50b] shadow-2xl transition-all duration-300 ${isDropdownOpen ? 'opacity-100 visible' : 'opacity-0 invisible'}`}>
                  <Link to="/Events" className="block px-6 py-4 text-white hover:bg-[#f9b50b] hover:text-[#221f1f] border-b border-white/5 transition-colors">All Events</Link>
                  <Link to="/annual-dinner" className="block px-6 py-4 text-white hover:bg-[#f9b50b] hover:text-[#221f1f]">Annual Dinner 2026</Link>
                </div>
              </div>
              <Link to="/gallery" className={`px-4 h-full flex items-center hover:text-[#f9b50b] ${isActive('/gallery') ? 'bg-[#f9b50b] text-[#221f1f]' : ''}`}>Gallery</Link>
              <Link to="/become-volunteer" className={`px-4 h-full flex items-center hover:text-[#f9b50b] ${isActive('/become-volunteer') ? 'bg-[#f9b50b] text-[#221f1f]' : ''}`}>Volunteer</Link>
              <Link to="/contact" className={`px-4 h-full flex items-center hover:text-[#f9b50b] ${isActive('/contact') ? 'bg-[#f9b50b] text-[#221f1f]' : ''}`}>Contact</Link>
            </div>

            <div className="flex items-center h-full ml-4 space-x-4">
              <Link to="/donate" className="bg-[#f9b50b] text-[#221f1f] px-6 md:px-10 h-full flex items-center font-black uppercase text-[12px] md:text-sm hover:bg-white transition-all border-l border-[#221f1f]">
                Donate <span className="hidden sm:inline ml-1">Now</span>
              </Link>
              <button onClick={() => setIsMobileMenuOpen(true)} className="lg:hidden text-[#f9b50b] text-2xl focus:outline-none p-2 border border-[#f9b50b]/20 rounded">
                <FaBars />
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* MOBILE MENU */}
      <div className={`lg:hidden fixed inset-0 z-[9999] bg-[#221f1f] transition-transform duration-500 ease-in-out transform ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`}>
        <div className="flex flex-col h-full p-6 overflow-y-auto">
          <div className="flex justify-between items-center mb-10 pb-6 border-b border-white/10">
            <img src="/Logo.png" alt="Logo" className="h-10 bg-white p-1 rounded" />
            <button onClick={() => setIsMobileMenuOpen(false)} className="text-[#f9b50b] text-3xl">
              <FaTimes />
            </button>
          </div>

          <div className="flex flex-col space-y-5 text-white text-lg font-bold uppercase tracking-widest">
            {navLinks.map((link) => (
              <Link key={link.name} to={link.path} className={`hover:text-[#f9b50b] ${isActive(link.path) ? 'text-[#f9b50b]' : ''}`}>
                {link.name}
              </Link>
            ))}
            <div className="pt-4 border-t border-white/10">
              <p className="text-[#f9b50b] text-xs mb-4 tracking-[0.2em]">Events</p>
              <Link to="/Events" className="block text-base mb-4 hover:text-[#f9b50b]">All Events</Link>
              <Link to="/annual-dinner" className="block text-base hover:text-[#f9b50b]">Annual Dinner 2026</Link>
            </div>
          </div>

          <div className="mt-auto pt-10">
            <p className="text-gray-500 text-[10px] uppercase mb-4 tracking-widest">Connect with us</p>
            <div className="flex space-x-6 text-[#f9b50b] text-2xl mb-8">
              <a href="https://www.facebook.com/ILinterfaith"><FaFacebookF /></a>
              <a href="https://x.com/IllinoisO22797"><FaTwitter /></a>
              <a href="https://www.instagram.com/illinoisinterfaithorg/"><FaInstagram /></a>
              <a href="https://www.linkedin.com/company/illinois-interfaith-organization-official/posts/?feedView=all"><FaLinkedinIn /></a>
            </div>
            <Link to="/donate" className="block w-full bg-[#f9b50b] text-[#221f1f] py-4 text-center font-black uppercase text-sm rounded">
              Donate Now
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;